import { action, computed, makeObservable, observable } from 'mobx';

import { PixelRoadGameId, WildHuntGameId } from '../constants';
import { RootStore } from '.';
import { finishLaunch, markLaunchStep } from '../services/launch-telemetry';

export class LoaderStore {

  private rootStore: RootStore;

  public gameLoaded = false;

  public gameLoadedTrigger = false;

  public videoCurrentTime = 0;

  /**
   * True once the game iframe element currently on screen fired `load`; GameLaunch clears it in the commit that
   * swaps the element. Not observable: nothing renders from it, the frame-retry timer reads it once. Telemetry
   * cannot serve this purpose because markLaunchStep ignores steps after finishLaunch, so a game that posts
   * GameLoaded before its frame `load` event looks "never loaded" to telemetry (that reloaded running games on 09-30).
   */
  public frameLoaded = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {

      gameLoaded: observable,
      setGameLoaded: action.bound,

      gameLoadedTrigger: observable,
      setGameLoadedTrigger: action.bound,

      videoCurrentTime: observable,
      setVideoCurrentTime: action.bound,

      showIChancyLoader: computed

    });
  }

  public setGameLoaded(value: boolean): void {
    this.gameLoaded = value;
  }

  public setGameLoadedTrigger(value: boolean): void {
    this.gameLoadedTrigger = value;
  }

  public setVideoCurrentTime(value: number): void {
    this.videoCurrentTime = value;
  }

  public setFrameLoaded(value: boolean): void {
    this.frameLoaded = value;
  }

  public get showIChancyLoader(): boolean {
    const { data } = this.rootStore.gameStore.launchData;
    if (!data) return false;
    const { gameId } = data;
    return gameId === PixelRoadGameId || gameId === WildHuntGameId;
  }

  public hideLoader(): void {
    markLaunchStep('ready');
    finishLaunch('game_ready');
    this.setGameLoadedTrigger(true);
    if (!this.showIChancyLoader) {
      this.setGameLoaded(true);
    }

    // uncomment old logic if you want to show loader till video end
    // let timeout = 1000;
    // if (this.videoCurrentTime) {
    //   const videoDuration = 3500;
    //   timeout = videoDuration - this.videoCurrentTime * 1000;
    // }
    // setTimeout(() => {
    //   this.setGameLoaded(true);
    // }, timeout);
  }

}
